import { render, staticRenderFns } from "./LayersAdding.vue?vue&type=template&id=b19f3f96&scoped=true&"
import script from "./LayersAdding.vue?vue&type=script&lang=js&"
export * from "./LayersAdding.vue?vue&type=script&lang=js&"
import style0 from "./LayersAdding.vue?vue&type=style&index=0&id=b19f3f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19f3f96",
  null
  
)

export default component.exports